import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import SelectInput from '../../../../components/SelectOptions';
import { Button } from '../../../../components/Button/Button.styles';
import { useTheme } from 'styled-components';
import { useEffect, useState } from 'react';
import Modal from '../../../../components/Modal/Modal';
import api from '../../../../utils/services/api';
import TextField from '../../../../components/TextField';
import { Box, Grid } from '@mui/material';
import InputFormat from '../../../GerenciarContas/components/InputFormat';
import { pixRefundCreateAction } from '../../../../store/fetchActions/pixRefundActions';
import { showAlert } from '../../../../store/ducks/sweetAlert';
import { removeNumericFormat } from 'react-number-format';

const ModalPixRefundCreateDevoluction = ({ open, handleClose, idTransaction }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const { errorMessagePixRefund, errorPixRefund } = useSelector((state) => state.pixRefund);

  const { handleSubmit, control } = useForm({});

  const [formOptions, setFormOptions] = useState([]);

  const callCreateDevoluctionAction = (data) => {
    const body = {
      DESCRICAO: data.details,
      VALOR_ESTORNADO: data.value,
      MOTIVO: data.reason,
      ID: idTransaction,
    };
    dispatch(pixRefundCreateAction(body, handleClose));
  };

  useEffect(async () => {
    const { data } = await api.get('/admin/pix/tipos/analise/devolucao');

    setFormOptions(data?.data);
  }, []);

  return (
    <Modal open={open} close={handleClose} title="Criar Devolução">
      <form onSubmit={handleSubmit(callCreateDevoluctionAction)}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ display: 'flex', gap: 10, mb: 5 }}>
            <SelectInput
              label="Motivo"
              name={'reason'}
              width={'10vw'}
              control={control}
              options={formOptions}
              initialValue={0}
            />
            <InputFormat
              control={control}
              formatType={'currency'}
              label={'Valor'}
              width={'20vw'}
              name={'value'}
              required={true}
              // decimalPlaces={4}
            />
          </Box>
          <TextField
            label={'Detalhes'}
            variant={'outlined'}
            name={'details'}
            // width={'100%'}
            multiline={true}
            minRows={3}
            // size="large"
            control={control}
          />
        </Box>

        <Button
          backgroundcolor={theme.colors.buttonConfirm}
          height={'3.125vw'}
          margin={'1vw 0 '}
          width={'100%'}
          hoverbgcolor={theme.colors.buttonConfirmHover}
          hovercolor={theme.colors.buttonConfirmHoverText}
          mycolor={theme.colors.buttonConfirmText}
          type="submit"
        >
          <span>CRIAR</span>
        </Button>
      </form>
    </Modal>
  );
};

export default ModalPixRefundCreateDevoluction;
